import React, { useEffect } from 'react';
import { Modal } from 'antd';
import CloseIcon from '@web-common/components/UI/Icons/svgs/CloseMailSvg';
import FeedbackContent from './feedbackContent';
import styles from './feedbackModal.module.scss';
const FeedbackModal = props => {
    const { visible, cancel, feedbackType = 'all' } = props;
    useEffect(() => {
        if (feedbackType === 'login') {
            document.body.classList.add('login-page');
        }
        else {
            document.body.classList.remove('login-page');
        }
    }, [feedbackType]);
    return (React.createElement(Modal, { visible: visible, centered: true, wrapClassName: feedbackType === 'login' ? styles.feedbackWrapper : '', footer: null, width: 800, closeIcon: React.createElement(CloseIcon, null), onCancel: cancel, className: `${styles.feedbackModal} extheme`, destroyOnClose: true },
        React.createElement(FeedbackContent, { cancel: cancel, feedbackType: feedbackType })));
};
export default FeedbackModal;
